import Vue from '@/setup'
import { EVENT_READY } from '@/config/events'

import { REENTRY_PREFIX_SP, REENTRY_PREFIX_DVP } from '@/config/constants'

import { BasketHelper, CollectiveHelper, RouteHelper } from '@/helpers'
import { ContractHelper } from '@/helpers/Contract'

const { $EventBus, $backend } = Vue.prototype

function _restoreBasket(token, next, query) {
  return $backend.ovp
    .loadBasket({ token })
    .then(basket => BasketHelper.checkConsistency(basket))
    .then(basket => BasketHelper.setLanguage(basket))
    .then(basket => BasketHelper.updateBasketSession(basket))
    .then(basket => CollectiveHelper.loadCollective(basket))
    .then(basket => BasketHelper.getAndSetProducts(basket))
    .then(basket => BasketHelper.getAndSetDistributionPartnerByBasket(basket))
    .then(basket => ContractHelper.loadContract(basket))
    .then(basket => RouteHelper.getRouteAfterReentry(basket))
    .then(name => next({ name, query }))
    .then(() => $EventBus.$emit(EVENT_READY, { isUnsecuredReentry: true }))
    .catch(() => {
      // basket requires authentication via tan
      return next()
    })
}

function _loadBasket(to, _from, next) {
  const token = to.params.token

  // check if reentry needs to be shown
  $backend.ovp.sendSMSTan(token).then(response => {
    // mobile is present, goto reentry
    if (response.mobile) {
      const payload = {
        mobile: response.mobile,
        distributionPartners: response.distributionPartners,
      }
      return BasketHelper.updateBasket(payload)
        .then(basket => BasketHelper.updateBasketSession(basket))
        .then(() => next())
        .then(() => $EventBus.$emit(EVENT_READY))

      // basket is not secured, just load it!
    } else {
      return _restoreBasket(token, next, to.query)
    }
  })
}

const routeOptions = {
  beforeEnter: _loadBasket,
  component: () => import(/* webpackChunkName: "screen-reentry" */ '@/modules/Configurator/screens/ReEntry.vue'),
  meta: {
    disableUnloadConfirmation: true,
    navigation: false,
    secured: false,
    allowNavigationToNextSteps: true,
    isReentry: true,
  },
  props: true,
}

export default [
  {
    ...routeOptions,
    name: 'reentry',
    path: `/:token(${REENTRY_PREFIX_DVP}[A0-Z9]{8})`,
  },
  {
    ...routeOptions,
    name: 'reentry.offer-application',
    path: `/:token(${REENTRY_PREFIX_SP}[A0-Z9]{8})`,
  },
]
